import {
  setAuthCredentials,
  throwErrorMessage,
  clearLocalStorageOnLogout,
} from 'dashboard/store/utils/api';
import { appendRevisionQuery } from 'dashboard/helper/appRevisionGuard';
import wootAPI from './apiClient';
import { getLoginRedirectURL } from '../helpers/AuthHelper';

export const login = async ({
  ssoAccountId,
  ssoConversationId,
  ...credentials
}) => {
  const response = await wootAPI.post('auth/sign_in', credentials);

  if (response.data?.two_factor_required) {
    return { two_factor_required: true };
  }

  setAuthCredentials(response);
  clearLocalStorageOnLogout();
  // Anexamos `?_v=APP_REVISION` para forzar que el navegador re-pida el HTML
  // índice del dashboard. Si el usuario tenía cacheado un bundle viejo previo
  // a un deploy, este redirect lo trae al último.
  const redirectUrl = getLoginRedirectURL({
    ssoAccountId,
    ssoConversationId,
    user: response.data.data,
  });
  window.location = appendRevisionQuery(redirectUrl);
  return response;
};

export const register = async creds => {
  try {
    const response = await wootAPI.post('api/v1/accounts.json', {
      account_name: creds.accountName.trim(),
      user_full_name: creds.fullName.trim(),
      email: creds.email,
      password: creds.password,
      h_captcha_client_response: creds.hCaptchaClientResponse,
    });
    setAuthCredentials(response);
    return response.data;
  } catch (error) {
    throwErrorMessage(error);
  }
  return null;
};

export const verifyPasswordToken = async ({ confirmationToken }) => {
  try {
    const response = await wootAPI.post('auth/confirmation', {
      confirmation_token: confirmationToken,
    });
    setAuthCredentials(response);
  } catch (error) {
    throwErrorMessage(error);
  }
};

export const setNewPassword = async ({
  resetPasswordToken,
  password,
  confirmPassword,
}) => {
  try {
    const response = await wootAPI.put('auth/password', {
      reset_password_token: resetPasswordToken,
      password_confirmation: confirmPassword,
      password,
    });
    setAuthCredentials(response);
  } catch (error) {
    throwErrorMessage(error);
  }
};

export const resetPassword = async ({ email }) =>
  wootAPI.post('auth/password', { email });
